import React, { useEffect, useState } from 'react';
import { db } from '../../service/firebaseconfig'
import { collection, getDocs } from 'firebase/firestore';
import { useParams, useNavigate } from 'react-router-dom';
import '../event/EventPage.css';
import LoaderSVG from "../Loader/LoaderSVG";

function EventPhotos() {
  const { eventId } = useParams();
  const navigate = useNavigate();

  const [alleventdata, setAlleventdata] = useState([]);
  const [event, setEvent] = useState(null);
  const [spinner, setSpinner] = useState(false)

  const AllEventdataRef = collection(db, "Event Details");

  const getAllEventDetails = async () => {
    setSpinner(true)
    try {
      const Eventdoc = await getDocs(AllEventdataRef);
      const filteredData = Eventdoc.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setAlleventdata(filteredData);

      // Find the specific event after all data is loaded
      const selectedEvent = filteredData.find((e) => e.id === eventId);
      setEvent(selectedEvent);
    } catch (err) {
      console.error("Error fetching events:", err);
    } finally {
      setSpinner(false)
    }
  };

  useEffect(() => {
    getAllEventDetails();
  }, [eventId]);

  // if (!alleventdata.length) {
  //   return <h2>Loading event data...</h2>;
  // }

  // if (!event) {
  //   return <h2 className="error-message">Event not found 404 Error</h2>;
  // }

  return (
    <section className="event-photos-section">
      <>{(spinner || alleventdata.length === 0 || event === null) ? <LoaderSVG/> : (
        <>
          <p onClick={() => navigate('/Resources')} className="back-to-gallery">
            <i className="fas fa-arrow-left"></i> Back to Events
          </p>

          <div className="event-details">
            <h2>{event.Event_Name}</h2>
            <p>{event.Description}</p>
            <div className="photo-container">
              {event.Pictures.map((picture, index) => (
                <img
                  key={index}
                  src={picture}
                  alt={`Gallery for ${event.Event_Name}`}
                  className="event-photo"
                />
              ))}
            </div>
          </div>
        </>)}
      </>
    </section>
  );
}

export default EventPhotos;
